import axios from "axios";
import auth from "./src/controllers/auth.controllers";
import myLocalStorage from "./src/utils/myLocalStorage";
import mySessionStorage from "./src/controllers/sessionStorage.controllers";
import { router } from "./src/main";

const isDev = import.meta.env.DEV;

const configCommon = {
  baseURL: isDev ? "/api" : import.meta.env.VITE_HOST_MONITOR.toString(),
  withCredentials: true
};

const axiosInstance = axios.create(configCommon);

axiosInstance.interceptors.response.use(
  response => response,
  async error => {
    const status = error.response?.status;
    if (status === 401) {
      auth.clear();
      window.location.href = "/";
    } else if (status === 403) {
      await auth.logout();
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
